import FormCreator from '../FormCreator/index';

const { Schema, TYPES } = FormCreator;

const ddObj = new Schema(TYPES.DROPDOWN, 'locale', 'Select Language', undefined, { required: true });
ddObj.values = [
  { value: 'en', label: 'English' },
  { value: 'iw', label: 'Hebrew - עברית' },
  { value: 'bg', label: 'Bulgarian - български' },
  { value: 'ru', label: 'Russian - русский' },
  { value: 'de', label: 'German - Deutsch' },
  { value: 'ar', label: 'Arabic - عربي' },
  { value: 'lv', label: 'Latvian - Latviski' },
  { value: 'fr', label: 'French - français'}
];

export default [ddObj];
